var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"25","height":"23","viewBox":"0 0 25 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"id":"Polygon 1","d":"M12.5 23L0.808657 0.5L24.1913 0.5L12.5 23Z","fill":"#666666"}})])}
var staticRenderFns = []

export { render, staticRenderFns }